// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"175":"3348bfa5","328":"3348bfa5","360":"3348bfa5","516":"3348bfa5","730":"3348bfa5","757":"3348bfa5","810":"3348bfa5","850":"3348bfa5","920":"3348bfa5"}[chunkId] + ".chunk.css";
};